import { Siren, ClipboardList, Boxes, Truck, Users, ShieldCheck, Clock, HeartHandshake, GraduationCap, Sparkles } from "lucide-react";

// Careers page content (editable). Rendered by pages/Careers.jsx.
export const positions = [
  {
    id: "emergency-technician",
    icon: Siren,
    title: "Emergency Technician",
    type: "Full-time · Rotating on-call shifts",
    location: "Toronto & GTA · Field",
    summary:
      "First on site after a water, fire or trauma loss. You stabilize the property, stop further damage and set the recovery in motion.",
    responsibilities: [
      "Respond to emergency dispatches within our 60-minute GTA target",
      "Perform water extraction, structural drying and containment set-ups",
      "Document scope, moisture readings and site conditions in real time",
      "Coordinate with adjusters, homeowners and project managers on site",
    ],
    requirements: [
      "IICRC WRT or equivalent an asset (training provided)",
      "Valid Ontario driver's licence and clean abstract",
      "Comfortable with physical work, PPE and 24/7 rotating availability",
    ],
  },
  {
    id: "contents-specialist",
    icon: ClipboardList,
    title: "Contents Specialist",
    type: "Full-time",
    location: "Toronto & GTA · Field + Warehouse",
    summary:
      "You run the room-by-room inventory, photograph, tag and produce claim-ready documentation adjusters can rely on.",
    responsibilities: [
      "Complete detailed inventories with photos, condition notes and labels",
      "Assess salvageable vs. non-salvageable items alongside project managers",
      "Prepare digital reports for adjusters using our contents software",
      "Handle heirlooms, electronics and documents with chain-of-custody discipline",
    ],
    requirements: [
      "1+ year in contents restoration, moving or claims handling preferred",
      "Sharp attention to detail and comfortable in a customer-facing role",
      "Basic computer literacy — tablet-based inventory workflows",
    ],
  },
  {
    id: "packout-crew",
    icon: Boxes,
    title: "Pack-Out Crew Member",
    type: "Full-time · Shift work",
    location: "Toronto & GTA · Field",
    summary:
      "Professional packers who protect what matters most — every carton labeled, tracked and moved with care.",
    responsibilities: [
      "Pack, wrap and label contents according to our chain-of-custody standards",
      "Load and unload trucks safely, respecting property protection protocols",
      "Support pack-back once the property is ready to receive contents again",
      "Work alongside contents specialists to keep inventories accurate",
    ],
    requirements: [
      "Physically fit — able to lift 50 lbs repeatedly",
      "Punctual, respectful, team-first attitude",
      "Prior moving, warehouse or restoration experience is a plus",
    ],
  },
  {
    id: "logistics-coordinator",
    icon: Truck,
    title: "Logistics Coordinator",
    type: "Full-time",
    location: "Toronto · Office + Warehouse",
    summary:
      "You keep the trucks, crews and storage bays moving in sync — matching schedules to every claim timeline.",
    responsibilities: [
      "Dispatch crews and route trucks across the GTA every day",
      "Manage secure storage intake, tracking and release",
      "Own scheduling conflicts before they become client problems",
      "Interface with project managers, drivers and warehouse team",
    ],
    requirements: [
      "2+ years in dispatch, logistics or fleet coordination",
      "Strong communicator — calm under pressure, clear on the radio",
      "Comfortable with scheduling software and Excel/Sheets",
    ],
  },
  {
    id: "project-manager",
    icon: Users,
    title: "Project Manager",
    type: "Full-time",
    location: "Toronto & GTA · Field + Office",
    summary:
      "The single point of contact from the first call to the final walk-through. You own the client relationship and the outcome.",
    responsibilities: [
      "Own scope, schedule and budget for every assigned loss",
      "Communicate proactively with adjusters, contractors and clients",
      "Lead crews on site and coordinate with trades and vendors",
      "Sign off on quality, documentation and final delivery",
    ],
    requirements: [
      "3+ years in restoration, construction management or insurance claims",
      "IICRC certifications an asset (WRT, ASD, FSRT)",
      "Excellent written English — reports and estimates must be adjuster-ready",
    ],
  },
  {
    id: "quality-compliance",
    icon: ShieldCheck,
    title: "Quality & Compliance Officer",
    type: "Full-time",
    location: "Toronto · Office + Field audits",
    summary:
      "Behind-the-scenes review of every project so paperwork, safety and workmanship stay consistent — every job, every time.",
    responsibilities: [
      "Audit files, photos and inventories for completeness",
      "Ride-along inspections to verify site safety and workmanship",
      "Maintain WSIB, health & safety and insurance documentation",
      "Feed findings back into training and standard operating procedures",
    ],
    requirements: [
      "Background in QA, health & safety or restoration operations",
      "Familiarity with WSIB, JHSC and industry safety standards",
      "Meticulous, diplomatic and comfortable challenging bad practice",
    ],
  },
];

export const perks = [
  {
    icon: Clock,
    title: "Meaningful work, real hours.",
    desc: "Every shift ends with a family more settled than when it began. We honour your time with predictable rotations and paid overtime.",
  },
  {
    icon: GraduationCap,
    title: "Training that stays with you.",
    desc: "IICRC certifications, safety training and equipment tickets — paid for and encouraged. Grow your career in a growing company.",
  },
  {
    icon: HeartHandshake,
    title: "A crew, not a roster.",
    desc: "Small teams, tight communication, real accountability. Coordinators pick up the phone; managers show up on site.",
  },
  {
    icon: Sparkles,
    title: "Modern tools.",
    desc: "Tablet-based inventories, current drying equipment and a fleet you'll actually want to drive. No paper clipboards, no cobbled workflows.",
  },
];
